import { ParseTimestampFilter as parseTimestamp } from 'ecx.saigon.ui.common';
import { REQUEST_TYPES_MAPPING } from '@/utils/constants';

export default [
  {
    name: 'id',
    label: 'Application #',
    field: (row) =>
      row.referenceVersion
        ? `${row.referenceNumber}/${row.referenceVersion}`
        : row.referenceNumber,
    required: true,
    sortable: true,
    align: 'left'
  },
  {
    name: 'requestType',
    label: 'Request Type',
    field: (row) => REQUEST_TYPES_MAPPING[row.approvalType],
    required: true,
    sortable: true,
    align: 'left'
  },
  {
    name: 'employeeName',
    label: 'Employee Name',
    sortable: true,
    align: 'left',
    field: (row) => row.employeeName
  },
  {
    name: 'payrollNumber',
    label: 'Payroll Number',
    align: 'left',
    field: (row) => row.payrollNumber
  },
  {
    name: 'costCentre',
    label: 'Cost Centre',
    align: 'left',
    field: (row) => row.costCenter
  },
  {
    name: 'requestedDate',
    label: 'Requested Date',
    sortable: true,
    align: 'left',
    field: (row) => row.createdAt._seconds,
    format: (date) => parseTimestamp(date)
  }
];
